export default class TabbedMediaContent {
    constructor (tabbedElement) {
        if (!tabbedElement) return;

        this.tabbedElement = tabbedElement;
        this.tabbedElementWrapper = tabbedElement.querySelector('.js-tabbed-content-wrap');
        this.tabbedContent = this.tabbedElement.querySelectorAll('.js-tabbed-content');
        this.arrowNext = this.tabbedElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.tabbedElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.tabbedElement.querySelector('.swiper-scrollbar');
        this.tabbedToggles = this.tabbedElement.querySelectorAll('.js-tabbed-toggle');

        if (this.tabbedContent) {
            const buttonType = this.tabbedToggles[0].dataset.type;
            this.tabbedContent.forEach((content) => {
                const slideType = content.dataset.type;
                if(buttonType == slideType) {
                    content.classList.add('active');
                } else {
                    content.classList.remove('active');
                }
            })
        }

        this.init()
    }

    init() {
        if (this.tabbedToggles) {
            this.tabbedToggles[0].classList.add('active');
            this.tabbedToggles.forEach(button => {
                button.addEventListener('click', () => {
                    this.tabbedToggles.forEach(buttonRemove => {
                        buttonRemove.classList.remove('active')
                    });

                    button.classList.add('active');

                    button.scrollIntoView({
                        behavior: 'smooth',
                        inline: 'center',
                        block: 'nearest'
                    });
                    
                    this.tabbedContent.forEach((slide) => {
                        const slideType = slide.dataset.type;
                        const buttonType = button.dataset.type;
                        if(buttonType == slideType) {
                            slide.classList.add('active');
                        } else {
                            slide.classList.remove('active');
                        }
                    })
                });
            });
        }
    }
}